import {gql} from '@apollo/client';

export const boardSettingsMutations = {
    CREATE_BOARD_SETTING: gql`
        mutation CreateBoardSettings($input: BoardSettingCreateRequestDTOInput!) {
            createBoardSettings(input: $input) {
                title
            }
        }
    `,
    UPDATE_BOARD_SETTING: gql`
        mutation UpdateBoardSettings($id: UUID!, $input: BaordSettingCreateEditDTOInput!) {
            updateBoardSettings(id: $id, input: $input) {
                id
                boardSettingKey
                boradId
                value
            }
        }
    `,
};
